// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarkerHistoryElement_wrapper__2j011","text-wrapper":"MarkerHistoryElement_text-wrapper__16bBm","box-location":"MarkerHistoryElement_box-location__3GZT9"};